import { gql, QueryHookOptions } from "@apollo/client";
import { CalendarDate, endOfMonth, startOfMonth } from "@internationalized/date";

import { useQuery } from "../hooks";

export type AvailabilityListItem = {
    id: string;
    date: string;
    soldOut: boolean;
    guidePriceFormattedText?: string;
};

export type AvailabilityList = {
    nodes: AvailabilityListItem[];
};

export type AvailabilityListResponse = {
    availabilityList: AvailabilityList;
};

export const AVAILABILITY_LIST_QUERY = gql`
    query useAvailabilityList($productId: String!, $includeSoldOut: Boolean, $startDate: Date!, $endDate: Date!) {
        availabilityList(
            productId: $productId
            filter: { startDate: $startDate, endDate: $endDate, includeSoldOut: $includeSoldOut }
        ) {
            total
            nodes {
                id
                date
                soldOut
            }
        }
    }
`;

const AVAILABILITY_LIST_QUERY_PASS = gql`
    query holibob($productId: String!, $includeSoldOut: Boolean) {
        availabilityList(productId: $productId, filter: { includeSoldOut: $includeSoldOut }) {
            total
            nodes {
                id
                date
                soldOut
            }
        }
    }
`;

type AvailabilityListPassData = { availabilityList: { total: number; nodes: Array<AvailabilityListItem> } };
export const useAvailabilityListPass = (productId: string, options?: QueryHookOptions<AvailabilityListPassData>) => {
    return useQuery<AvailabilityListPassData>(AVAILABILITY_LIST_QUERY_PASS, {
        variables: {
            productId,
            includeSoldOut: false,
        },
        ...options,
    });
};

export const useAvailabilityList = (
    productId: string,
    calendarDate: CalendarDate,
    query = AVAILABILITY_LIST_QUERY,
    includeSoldOut = true,
    onCompleted?: (data: AvailabilityListResponse) => void
) => {
    const response = useQuery<AvailabilityListResponse>(query, {
        variables: {
            productId,
            startDate: startOfMonth(calendarDate).toString(),
            endDate: endOfMonth(calendarDate).toString(),
            includeSoldOut,
        },
        // TODO fix so that fetchPolociy is no-cache on page navigation but on rerender it is cached
        fetchPolicy: "no-cache",
        onCompleted,
    });

    return response;
};
